const Wishlist = {
  getItems() {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  },
  addItem(id, title, price, image, url) {
    const items = this.getItems();
    if (!items.find(i => i.id === id)) {
      items.push({ id, title, price, image, url });
      localStorage.setItem('wishlist', JSON.stringify(items));
    }
  },
  removeItem(id) {
    const items = this.getItems().filter(i => i.id !== id);
    localStorage.setItem('wishlist', JSON.stringify(items));
  },
  hasItem(id) {
    return this.getItems().some(i => i.id === id);
  },
  getCount() {
    return this.getItems().length;
  }
};

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const id = btn.dataset.id;
    if (Wishlist.hasItem(id)) {
      btn.classList.add('active');
      btn.innerHTML = '❤️';
    }
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (Wishlist.hasItem(id)) {
        Wishlist.removeItem(id);
        btn.classList.remove('active');
        btn.innerHTML = '🤍';
      } else {
        Wishlist.addItem(
          id,
          btn.dataset.title,
          btn.dataset.price,
          btn.dataset.image,
          btn.dataset.url
        );
        btn.classList.add('active');
        btn.innerHTML = '❤️';
      }
      document.querySelectorAll('.wishlist-count').forEach(el => {
        el.textContent = Wishlist.getCount();
      });
    });
  });
});